export const contacts = [
  {
    id: "mark",
    name: "Mark",
    status: "Online",
    role: "Product Designer",
    email: "mark@t4lk.dev",
    about: "Focuses on product strategy, flows and polished interface decisions."
  },
  {
    id: "lester",
    name: "Lester",
    status: "Away",
    role: "Frontend Developer",
    email: "lester@t4lk.dev",
    about: "Works on reusable components, state management and accessibility."
  },
  {
    id: "rebeca",
    name: "Rebeca",
    status: "Online",
    role: "UI Engineer",
    email: "rebeca@t4lk.dev",
    about: "Loves visual systems, animations and detail-oriented UI work."
  },
  {
    id: "astrodev",
    name: "Astrodev",
    status: "Offline",
    role: "Mentor",
    email: "astrodev@t4lk.dev",
    about: "Helps teams improve architecture and technical decision making."
  }
]